var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhonePauseCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#13D246;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Phone / pause call") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B_Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1999.000000, -3529.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Structure",
    transform: "translate(133.000000, 107.000000)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "phone_pause_call",
    transform: "translate(2.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone_x5F_pause_x5F_call"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 34,
    y: 1,
    className: "st0",
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 1,
    className: "st0",
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M29.5,24.7l6.7,5.5c0.5,0.4,0.5,1.1,0,1.5c-0.3,0.3-0.6,0.5-0.9,0.7c-1.8,1.4-3.9,2.6-6.2,3.3 c-1.4,0.5-2.9,0.4-4.2-0.2C14.4,31.1,5.9,22.6,1.4,12c-0.6-1.3-0.7-2.8-0.2-4.2C2,5.5,3.1,3.5,4.6,1.6C4.8,1.3,5,1,5.3,0.7 c0.4-0.5,1.1-0.4,1.5,0l5.5,6.7c0.3,0.4,0.3,1-0.1,1.3L10,11c-0.7,0.7-0.8,1.7-0.3,2.5C13.3,19,18,23.7,23.6,27.3 c0.8,0.5,1.8,0.4,2.5-0.3l2.2-2.2C28.6,24.4,29.1,24.4,29.5,24.7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhonePauseCall);
export default __webpack_public_path__ + "static/media/icon-phone_pause_call.d2113a1861eac0343139208b8fc1b1df.svg";
export { ForwardRef as ReactComponent };